import { createReducer } from '@reduxjs/toolkit';

import {
  setAllObjects,
  setObject,
  setUpdatedObject,
  setDeleteObject,
} from '../../Actions/ObjectsActions';

const objects = createReducer([], {
  [setAllObjects]: (state, action) => {
    return action.payload;
  },
  [setObject]: (state, action) => {
    return [action.payload, ...state];
  },
  [setUpdatedObject]: (state, action) => {
    return state.map(object => {
      if (object._id === action.payload._id) {
        return action.payload;
      }
      return object;
    });
  },
  [setDeleteObject]: (state, action) => {
    return state.filter(object => object._id !== action.payload._id);
  },
});

export default objects;
